export default {"src":"/login-app/[GIT_HASH]/_next/static/media/run_with_subruns.5e6192b9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};